module.exports = __webpack_public_path__ + "img/swipe-down.8c6ebb0f.svg";